//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/model";
import { apiurl } from '@/config';

class _ChatRoomClient {

    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ChatRoom> {
                        return CommonServices.defaultGet<OM.ChatRoom>(apiurl + 'api/ChatRoom/GetById',{ identifier }, showSpinner);

                    }
    

                
            getVmById(
                identifier:string,showSpinner = true): Promise<OM.ChatRoomVm> {
                        return CommonServices.defaultGet<OM.ChatRoomVm>(apiurl + 'api/ChatRoom/GetVmById',{ identifier }, showSpinner);

                    }
    

                
            getChatMessages(
                chatIdentifier:string,
                skip:number,
                take:number,showSpinner = true): Promise<OM.ChatMessage[]> {
                        return CommonServices.defaultGet<OM.ChatMessage[]>(apiurl + 'api/ChatRoom/GetChatMessages',{ chatIdentifier, skip, take }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.ChatRoomVm[]> {
                        return CommonServices.defaultGet<OM.ChatRoomVm[]>(apiurl + 'api/ChatRoom/GetAll',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.ChatRoom,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ChatRoom/Save', item,{}, showSpinner );

                    }
    

                
            updateChatRoom(
                item:OM.ChatRoomVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/ChatRoom/UpdateChatRoom', item,{}, showSpinner );

                    }
    

                
            subscribe(
                identifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/Subscribe',{ identifier, userIdentifier }, showSpinner);

                    }
    

                
            unSubscribe(
                identifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/UnSubscribe',{ identifier, userIdentifier }, showSpinner);

                    }
    

                
            removeMessage(
                chatRoomIdentifier:string,
                messageIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/RemoveMessage',{ chatRoomIdentifier, messageIdentifier }, showSpinner);

                    }
    

                
            removeMessageMultiple(
                vm:OM.RemoveChatMessagesVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/ChatRoom/RemoveMessageMultiple', vm,{}, showSpinner );

                    }
    

                
            deleteChatRoom(
                chatRoomIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/DeleteChatRoom',{ chatRoomIdentifier }, showSpinner);

                    }
    

                
            disableChat(
                chatIdentifier:string,
                disable:boolean,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/DisableChat',{ chatIdentifier, disable }, showSpinner);

                    }
    }

export let ChatRoomClient = new _ChatRoomClient();

class _HelpTicketClient {

    

                
            assignToUser(
                chatIdentifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/HelpTicket/AssignToUser',{ chatIdentifier, userIdentifier }, showSpinner);

                    }
    

                
            saveHelpTicket(
                vm:OM.SaveHelpTicketVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/HelpTicket/SaveHelpTicket', vm,{}, showSpinner );

                    }
    

                
            newTicketFromAdmin(
                vm:OM.SaveHelpTicketVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/HelpTicket/NewTicketFromAdmin', vm,{}, showSpinner );

                    }
    

                
            getAllPaginated(
                vm:OM.TicketListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfHelpTicketVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfHelpTicketVm>(apiurl + 'api/HelpTicket/GetAllPaginated', vm,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.HelpTicketVm[]> {
                        return CommonServices.defaultGet<OM.HelpTicketVm[]>(apiurl + 'api/HelpTicket/GetAll',{  }, showSpinner);

                    }
    

                
            canOpenTicketV2(showSpinner = true): Promise<OM.GetOrariAperturaTicketVm> {
                        return CommonServices.defaultGet<OM.GetOrariAperturaTicketVm>(apiurl + 'api/HelpTicket/CanOpenTicketV2',{  }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/HelpTicket/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/HelpTicket/ExportExcel',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ChatRoom> {
                        return CommonServices.defaultGet<OM.ChatRoom>(apiurl + 'api/HelpTicket/GetById',{ identifier }, showSpinner);

                    }
    

                
            getByClienteIdentifier(
                clienteIdentifier:string,showSpinner = true): Promise<OM.HelpTicketVm[]> {
                        return CommonServices.defaultGet<OM.HelpTicketVm[]>(apiurl + 'api/HelpTicket/GetByClienteIdentifier',{ clienteIdentifier }, showSpinner);

                    }
    

                
            chiudiTicket(
                ticketIdentifier:string,
                disable:boolean,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/HelpTicket/ChiudiTicket',{ ticketIdentifier, disable }, showSpinner);

                    }
    

                
            setGestitoDa(
                ticketIdentifier:string,
                value:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/HelpTicket/SetGestitoDa',{ ticketIdentifier, value }, showSpinner);

                    }
    

                
            setAssignedUser(
                ticketIdentifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/HelpTicket/SetAssignedUser',{ ticketIdentifier, userIdentifier }, showSpinner);

                    }
    

                
            getExternals(showSpinner = true): Promise<OM.HelpTicketVm[]> {
                        return CommonServices.defaultGet<OM.HelpTicketVm[]>(apiurl + 'api/HelpTicket/GetExternals',{  }, showSpinner);

                    }
    }

export let HelpTicketClient = new _HelpTicketClient();

class _NetworkClient {

    

                
            getDescendants(
                userIdentifier:string,
                showClienti:boolean,
                showLead:boolean,showSpinner = true): Promise<OM.NetworkUserVm[]> {
                        return CommonServices.defaultGet<OM.NetworkUserVm[]>(apiurl + 'api/Network/GetDescendants',{ userIdentifier, showClienti, showLead }, showSpinner);

                    }
    

                
            getNetworkUser(
                userIdentifier:string,showSpinner = true): Promise<OM.NetworkUserVm> {
                        return CommonServices.defaultGet<OM.NetworkUserVm>(apiurl + 'api/Network/GetNetworkUser',{ userIdentifier }, showSpinner);

                    }
    

                
            getFirstLineOf(
                userIdentifier:string,
                showClienti:boolean,
                showLead:boolean,showSpinner = true): Promise<OM.NetworkUserVm[]> {
                        return CommonServices.defaultGet<OM.NetworkUserVm[]>(apiurl + 'api/Network/GetFirstLineOf',{ userIdentifier, showClienti, showLead }, showSpinner);

                    }
    }

export let NetworkClient = new _NetworkClient();

class _BackendNotificationClient {

    

                
            countUnread(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/BackendNotification/CountUnread',{ userIdentifier }, showSpinner);

                    }
    

                
            getByUser(
                userIdentifier:string,
                unreadOnly:boolean,
                page:number,
                perPage:number,showSpinner = true): Promise<OM.TablePagedResultOfBaseBackendNotification> {
                        return CommonServices.defaultGet<OM.TablePagedResultOfBaseBackendNotification>(apiurl + 'api/BackendNotification/GetByUser',{ userIdentifier, unreadOnly, page, perPage }, showSpinner);

                    }
    

                
            setAllRead(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BackendNotification/SetAllRead',{ userIdentifier }, showSpinner);

                    }
    

                
            setRead(
                backendNotificationIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BackendNotification/SetRead',{ backendNotificationIdentifier }, showSpinner);

                    }
    }

export let BackendNotificationClient = new _BackendNotificationClient();

class _BackendRoleConfigClient {

    

                
            getAll(showSpinner = true): Promise<OM.BackendRoleConfig[]> {
                        return CommonServices.defaultGet<OM.BackendRoleConfig[]>(apiurl + 'api/BackendRoleConfig/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.BackendRoleConfig> {
                        return CommonServices.defaultGet<OM.BackendRoleConfig>(apiurl + 'api/BackendRoleConfig/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.BackendRoleConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/BackendRoleConfig/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BackendRoleConfig/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getRoles(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/BackendRoleConfig/GetRoles',{  }, showSpinner);

                    }
    

                
            getPermissionModules(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/BackendRoleConfig/GetPermissionModules',{  }, showSpinner);

                    }
    

                
            getClientModulesByRole(
                role:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/BackendRoleConfig/GetClientModulesByRole',{ role }, showSpinner);

                    }
    }

export let BackendRoleConfigClient = new _BackendRoleConfigClient();

class _CardsClient {

    

                
            getAll(
                vm:OM.CardListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfCard> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfCard>(apiurl + 'api/Cards/GetAll', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.Card> {
                        return CommonServices.defaultGet<OM.Card>(apiurl + 'api/Cards/GetById',{ identifier }, showSpinner);

                    }
    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.Card[]> {
                        return CommonServices.defaultGet<OM.Card[]>(apiurl + 'api/Cards/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.Card,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Cards/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Cards/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/Cards/ExportExcel',{  }, showSpinner);

                    }
    

                
            getAccountBalance(
                userIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Cards/GetAccountBalance',{ userIdentifier }, showSpinner);

                    }
    

                
            get3dsPassword(
                cardIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Cards/Get3dsPassword',{ cardIdentifier }, showSpinner);

                    }
    

                
            getCardPin(
                cardIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Cards/GetCardPin',{ cardIdentifier }, showSpinner);

                    }
    

                
            getCardTransactions(
                cardIdentifier:string,
                fromRecord:number,
                recordsCount:number,showSpinner = true): Promise<OM.Transaction[]> {
                        return CommonServices.defaultGet<OM.Transaction[]>(apiurl + 'api/Cards/GetCardTransactions',{ cardIdentifier, fromRecord, recordsCount }, showSpinner);

                    }
    }

export let CardsClient = new _CardsClient();

class _CommissionClient {

    

                
            getByUplinerIdentifier(
                vm:OM.CommissionsByUplinerIdentifierListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseCommission> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseCommission>(apiurl + 'api/Commission/GetByUplinerIdentifier', vm,{}, showSpinner );

                    }
    

                
            getAll(
                vm:OM.ProvvigioniListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseCommission> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseCommission>(apiurl + 'api/Commission/GetAll', vm,{}, showSpinner );

                    }
    

                
            exportExcel(
                vm:OM.ProvvigioniListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/Commission/ExportExcel', vm,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Commission/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            recalculateDirectSalesByPurchase(
                purchaseIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Commission/RecalculateDirectSalesByPurchase',{ purchaseIdentifier }, showSpinner);

                    }
    

                
            getByPurchase(
                purchaseIdentifier:string,showSpinner = true): Promise<OM.BaseCommission[]> {
                        return CommonServices.defaultGet<OM.BaseCommission[]>(apiurl + 'api/Commission/GetByPurchase',{ purchaseIdentifier }, showSpinner);

                    }
    }

export let CommissionClient = new _CommissionClient();

class _DashboardClient {

    

                
            getDashPortafoglio(
                userIdentifier:string,showSpinner = true): Promise<OM.DashboardPortafoglioVm> {
                        return CommonServices.defaultGet<OM.DashboardPortafoglioVm>(apiurl + 'api/Dashboard/GetDashPortafoglio',{ userIdentifier }, showSpinner);

                    }
    

                
            getPerformanceChartValues(
                userIdentifier:string,
                start:string,
                end:string,showSpinner = true): Promise<OM.PerformanceChartValuesVm> {
                        return CommonServices.defaultGet<OM.PerformanceChartValuesVm>(apiurl + 'api/Dashboard/GetPerformanceChartValues',{ userIdentifier, start, end }, showSpinner);

                    }
    

                
            getContatoreAttivi(
                userIdentifier:string,showSpinner = true): Promise<OM.ContatoreAttiviVm> {
                        return CommonServices.defaultGet<OM.ContatoreAttiviVm>(apiurl + 'api/Dashboard/GetContatoreAttivi',{ userIdentifier }, showSpinner);

                    }
    

                
            getSubUsersByQualifica(
                userIdentifier:string,
                qualificationCode:string,showSpinner = true): Promise<OM.DashboardProfileVm[]> {
                        return CommonServices.defaultGet<OM.DashboardProfileVm[]>(apiurl + 'api/Dashboard/GetSubUsersByQualifica',{ userIdentifier, qualificationCode }, showSpinner);

                    }
    

                
            getGuadagniChartValues(
                userIdentifier:string,
                useNegatives:boolean,showSpinner = true): Promise<OM.GuadagniChartValuesVm> {
                        return CommonServices.defaultGet<OM.GuadagniChartValuesVm>(apiurl + 'api/Dashboard/GetGuadagniChartValues',{ userIdentifier, useNegatives }, showSpinner);

                    }
    

                
            getBestVenditori(
                userIdentifier:string,
                limit:number,
                start:string,
                end:string,showSpinner = true): Promise<OM.VenditoreBestVm[]> {
                        return CommonServices.defaultGet<OM.VenditoreBestVm[]>(apiurl + 'api/Dashboard/GetBestVenditori',{ userIdentifier, limit, start, end }, showSpinner);

                    }
    

                
            getDashProfile(
                userIdentifier:string,showSpinner = true): Promise<OM.DashboardProfileVm> {
                        return CommonServices.defaultGet<OM.DashboardProfileVm>(apiurl + 'api/Dashboard/GetDashProfile',{ userIdentifier }, showSpinner);

                    }
    

                
            getDashRicevute(
                userIdentifier:string,showSpinner = true): Promise<OM.UserPaymentReceipt[]> {
                        return CommonServices.defaultGet<OM.UserPaymentReceipt[]>(apiurl + 'api/Dashboard/GetDashRicevute',{ userIdentifier }, showSpinner);

                    }
    

                
            getDashSubUsers(
                userIdentifier:string,showSpinner = true): Promise<OM.UserCardVm[]> {
                        return CommonServices.defaultGet<OM.UserCardVm[]>(apiurl + 'api/Dashboard/GetDashSubUsers',{ userIdentifier }, showSpinner);

                    }
    

                
            hasSubUsers(
                userIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Dashboard/HasSubUsers',{ userIdentifier }, showSpinner);

                    }
    

                
            getUserObiettivoCard(
                userIdentifier:string,
                start:string,
                end:string,showSpinner = true): Promise<OM.UserObiettivoCardVm> {
                        return CommonServices.defaultGet<OM.UserObiettivoCardVm>(apiurl + 'api/Dashboard/GetUserObiettivoCard',{ userIdentifier, start, end }, showSpinner);

                    }
    

                
            getSubUserObiettivoCard(
                userIdentifier:string,showSpinner = true): Promise<OM.UserObiettivoCardVm[]> {
                        return CommonServices.defaultGet<OM.UserObiettivoCardVm[]>(apiurl + 'api/Dashboard/GetSubUserObiettivoCard',{ userIdentifier }, showSpinner);

                    }
    

                
            exportDashboards(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/Dashboard/ExportDashboards',{  }, showSpinner);

                    }
    

                
            exportDashboardMensile(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/Dashboard/ExportDashboardMensile',{  }, showSpinner);

                    }
    }

export let DashboardClient = new _DashboardClient();

class _DashboardDocumentClient {

    

                
            getByFolder(
                folder:string,showSpinner = true): Promise<OM.DashboardDocument[]> {
                        return CommonServices.defaultGet<OM.DashboardDocument[]>(apiurl + 'api/DashboardDocument/GetByFolder',{ folder }, showSpinner);

                    }
    

                
            getFolders(showSpinner = true): Promise<OM.GetFoldersResponseVm[]> {
                        return CommonServices.defaultGet<OM.GetFoldersResponseVm[]>(apiurl + 'api/DashboardDocument/GetFolders',{  }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.DashboardDocument[]> {
                        return CommonServices.defaultGet<OM.DashboardDocument[]>(apiurl + 'api/DashboardDocument/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.DashboardDocument> {
                        return CommonServices.defaultGet<OM.DashboardDocument>(apiurl + 'api/DashboardDocument/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.DashboardDocument,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/DashboardDocument/Save', item,{}, showSpinner );

                    }
    

                
            addUserRead(
                docIdentifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DashboardDocument/AddUserRead',{ docIdentifier, userIdentifier }, showSpinner);

                    }
    

                
            delete(
                docIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DashboardDocument/Delete',{ docIdentifier }, showSpinner);

                    }
    }

export let DashboardDocumentClient = new _DashboardDocumentClient();

class _DeferredPaymentClient {

    

                
            getAll(showSpinner = true): Promise<OM.DeferredPayment[]> {
                        return CommonServices.defaultGet<OM.DeferredPayment[]>(apiurl + 'api/DeferredPayment/GetAll',{  }, showSpinner);

                    }
    

                
            exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/DeferredPayment/ExportExcel',{  }, showSpinner);

                    }
    

                
            createDeferredPaymentFromBackoffice(
                vm:OM.CreateDeferredPaymentFromCartVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/DeferredPayment/CreateDeferredPaymentFromBackoffice', vm,{}, showSpinner );

                    }
    

                
            createCardTopUp(
                vm:OM.CreateCardTopUpVm,showSpinner = true): Promise<OM.CardTopUp> {
                        return CommonServices.defaultPost<OM.CardTopUp>(apiurl + 'api/DeferredPayment/CreateCardTopUp', vm,{}, showSpinner );

                    }
    

                
            getPendingTopUp(
                cardNumber:string,showSpinner = true): Promise<OM.CardTopUp> {
                        return CommonServices.defaultGet<OM.CardTopUp>(apiurl + 'api/DeferredPayment/GetPendingTopUp',{ cardNumber }, showSpinner);

                    }
    

                
            createDeferredPayment(
                vm:OM.CreateDeferredPaymentFromCartVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/DeferredPayment/CreateDeferredPayment', vm,{}, showSpinner );

                    }
    

                
            sendPagamentoBonificoDetails(
                customerIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/SendPagamentoBonificoDetails',{ customerIdentifier }, showSpinner);

                    }
    

                
            getPendingByCustomer(
                customerIdentifier:string,showSpinner = true): Promise<OM.DeferredPayment[]> {
                        return CommonServices.defaultGet<OM.DeferredPayment[]>(apiurl + 'api/DeferredPayment/GetPendingByCustomer',{ customerIdentifier }, showSpinner);

                    }
    

                
            getTopUpByCard(
                cardNumber:string,showSpinner = true): Promise<OM.CardTopUp[]> {
                        return CommonServices.defaultGet<OM.CardTopUp[]>(apiurl + 'api/DeferredPayment/GetTopUpByCard',{ cardNumber }, showSpinner);

                    }
    

                
            getByFilterVm(
                vm:OM.PagamentoBonificoListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfDeferredPayment> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfDeferredPayment>(apiurl + 'api/DeferredPayment/GetByFilterVm', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.DeferredPayment> {
                        return CommonServices.defaultGet<OM.DeferredPayment>(apiurl + 'api/DeferredPayment/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                pagamento:OM.DeferredPayment,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/DeferredPayment/Save', pagamento,{}, showSpinner );

                    }
    

                
            confermaPagamento(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/ConfermaPagamento',{ identifier }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/Delete',{ identifier }, showSpinner);

                    }
    

                
            annullaPagamentoBonifico(
                deferredPaymentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/AnnullaPagamentoBonifico',{ deferredPaymentIdentifier }, showSpinner);

                    }
    

                
            cancelDeferredPayment(
                deferredPaymentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/CancelDeferredPayment',{ deferredPaymentIdentifier }, showSpinner);

                    }
    

                
            removeCommento(
                itemIdentifier:string,
                commentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/RemoveCommento',{ itemIdentifier, commentIdentifier }, showSpinner);

                    }
    

                
            removeCommentoInterno(
                itemIdentifier:string,
                commentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/RemoveCommentoInterno',{ itemIdentifier, commentIdentifier }, showSpinner);

                    }
    }

export let DeferredPaymentClient = new _DeferredPaymentClient();

class _FaqNodeClient {

    

                
            getById(
                faqNodeIdentifier:string,showSpinner = true): Promise<OM.FaqNode> {
                        return CommonServices.defaultGet<OM.FaqNode>(apiurl + 'api/FaqNode/GetById',{ faqNodeIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.FaqNode,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/FaqNode/Save', item,{}, showSpinner );

                    }
    

                
            addAnswerToNode(
                nodeIdentifier:string,showSpinner = true): Promise<OM.FaqNodeText> {
                        return CommonServices.defaultGet<OM.FaqNodeText>(apiurl + 'api/FaqNode/AddAnswerToNode',{ nodeIdentifier }, showSpinner);

                    }
    

                
            removeAnswerToNode(
                nodeIdentifier:string,
                answerIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/FaqNode/RemoveAnswerToNode',{ nodeIdentifier, answerIdentifier }, showSpinner);

                    }
    

                
            getRoot(showSpinner = true): Promise<OM.FaqNode> {
                        return CommonServices.defaultGet<OM.FaqNode>(apiurl + 'api/FaqNode/GetRoot',{  }, showSpinner);

                    }
    }

export let FaqNodeClient = new _FaqNodeClient();

class _GlobalConfigClient {

    

                
            getConfig(showSpinner = true): Promise<OM.GlobalConfig> {
                        return CommonServices.defaultGet<OM.GlobalConfig>(apiurl + 'api/GlobalConfig/GetConfig',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.GlobalConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/GlobalConfig/Save', item,{}, showSpinner );

                    }
    

                
            getAmazonRegions(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/GlobalConfig/GetAmazonRegions',{  }, showSpinner);

                    }
    

                
            getAmazonBuckets(
                region:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/GlobalConfig/GetAmazonBuckets',{ region }, showSpinner);

                    }
    

                
            getRootFolders(
                region:string,
                bucket:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/GlobalConfig/GetRootFolders',{ region, bucket }, showSpinner);

                    }
    }

export let GlobalConfigClient = new _GlobalConfigClient();

class _InAppNotificationClient {

    

                
            countUnread(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/InAppNotification/CountUnread',{ userIdentifier }, showSpinner);

                    }
    

                
            getByCliente(
                userIdentifier:string,showSpinner = true): Promise<OM.InAppNotification[]> {
                        return CommonServices.defaultGet<OM.InAppNotification[]>(apiurl + 'api/InAppNotification/GetByCliente',{ userIdentifier }, showSpinner);

                    }
    

                
            getNextByCliente(
                userIdentifier:string,showSpinner = true): Promise<OM.InAppNotification> {
                        return CommonServices.defaultGet<OM.InAppNotification>(apiurl + 'api/InAppNotification/GetNextByCliente',{ userIdentifier }, showSpinner);

                    }
    

                
            setRead(
                notificationIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/InAppNotification/SetRead',{ notificationIdentifier }, showSpinner);

                    }
    }

export let InAppNotificationClient = new _InAppNotificationClient();

class _LocalizedClient {

    

                
            saveAnonymousLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Localized/SaveAnonymousLocalizedValue', item,{}, showSpinner );

                    }
    

                
            saveLocalizedEntity(
                item:OM.LocalizedEntity,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Localized/SaveLocalizedEntity', item,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                        return CommonServices.defaultGet<OM.LocalizedEntity[]>(apiurl + 'api/Localized/GetAll',{  }, showSpinner);

                    }
    

                
            getEnabledLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/Localized/GetEnabledLanguages',{  }, showSpinner);

                    }
    

                
            getSupportedLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/Localized/GetSupportedLanguages',{  }, showSpinner);

                    }
    

                
            saveLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Localized/SaveLocalizedValue', item,{}, showSpinner );

                    }
    

                
            editLocalizedValue(
                value:OM.LocalizedEntity,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Localized/EditLocalizedValue', value,{}, showSpinner );

                    }
    }

export let LocalizedClient = new _LocalizedClient();

class _LoginClient {

    

                
            login(
                vm:OM.LoginVm,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultPost<OM.LoginData>(apiurl + 'api/Login/Login', vm,{}, showSpinner );

                    }
    

                
            loginWithTempPassword(
                vm:OM.LoginVm,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultPost<OM.LoginData>(apiurl + 'api/Login/LoginWithTempPassword', vm,{}, showSpinner );

                    }
    

                
            switchToAccount(
                userIdentifier:string,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultGet<OM.LoginData>(apiurl + 'api/Login/SwitchToAccount',{ userIdentifier }, showSpinner);

                    }
    

                
            checkEmailAvailable(
                email:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Login/CheckEmailAvailable',{ email }, showSpinner);

                    }
    

                
            register(
                vm:OM.RegisterVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Login/Register', vm,{}, showSpinner );

                    }
    

                
            sendTempPassword(
                username:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Login/SendTempPassword',{ username }, showSpinner);

                    }
    

                
            sendSmsPassword(
                username:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Login/SendSmsPassword',{ username }, showSpinner);

                    }
    

                
            setNewPassword(
                password:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Login/SetNewPassword',{ password }, showSpinner);

                    }
    

                
            refreshLogin(showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultGet<OM.LoginData>(apiurl + 'api/Login/RefreshLogin',{  }, showSpinner);

                    }
    }

export let LoginClient = new _LoginClient();

class _MagiaClient {

    

                
            getPammDuplicate(
                psw:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Magia/GetPammDuplicate',{ psw }, showSpinner);

                    }
    

                
            convertReceiptsToWallet(
                psw:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Magia/ConvertReceiptsToWallet',{ psw }, showSpinner);

                    }
    

                
            setPaidOnCommissions(
                psw:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Magia/SetPaidOnCommissions',{ psw }, showSpinner);

                    }
    

                
            resaveAllUsers(
                psw:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Magia/ResaveAllUsers',{ psw }, showSpinner);

                    }
    

                
            trimInvestmentIds(
                psw:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Magia/TrimInvestmentIds',{ psw }, showSpinner);

                    }
    

                
            activatePammForAll(
                psw:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Magia/ActivatePammForAll',{ psw }, showSpinner);

                    }
    

                
            fixDirectSaleCommissions(
                psw:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Magia/FixDirectSaleCommissions',{ psw }, showSpinner);

                    }
    

                
            resaveVouchers(
                psw:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Magia/ResaveVouchers',{ psw }, showSpinner);

                    }
    }

export let MagiaClient = new _MagiaClient();

class _MailEventClient {

    

                
            getMailEvents(showSpinner = true): Promise<OM.MailEventDefinition[]> {
                        return CommonServices.defaultGet<OM.MailEventDefinition[]>(apiurl + 'api/MailEvent/GetMailEvents',{  }, showSpinner);

                    }
    

                
            getByName(
                name:string,showSpinner = true): Promise<OM.MailEventDefinition> {
                        return CommonServices.defaultGet<OM.MailEventDefinition>(apiurl + 'api/MailEvent/GetByName',{ name }, showSpinner);

                    }
    }

export let MailEventClient = new _MailEventClient();

class _MailSentLogClient {

    

                
            getAllPaginated(
                vm:OM.MailSentLogListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfMailSentLog> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfMailSentLog>(apiurl + 'api/MailSentLog/GetAllPaginated', vm,{}, showSpinner );

                    }
    }

export let MailSentLogClient = new _MailSentLogClient();

class _MembershipClient {

    

                
            getByFilterVm(
                vm:OM.MembershipListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfMembership> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfMembership>(apiurl + 'api/Membership/GetByFilterVm', vm,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Membership/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getByUserIdentifier(
                userIdentifier:string,showSpinner = true): Promise<OM.Membership> {
                        return CommonServices.defaultGet<OM.Membership>(apiurl + 'api/Membership/GetByUserIdentifier',{ userIdentifier }, showSpinner);

                    }
    

                
            hasSignedContracts(
                userIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Membership/HasSignedContracts',{ userIdentifier }, showSpinner);

                    }
    

                
            generateContractForMembership(
                membershipIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Membership/GenerateContractForMembership',{ membershipIdentifier }, showSpinner);

                    }
    

                
            signMembershipWithOtp(
                membershipIdentifier:string,
                otp:string,showSpinner = true): Promise<OM.Membership> {
                        return CommonServices.defaultGet<OM.Membership>(apiurl + 'api/Membership/SignMembershipWithOtp',{ membershipIdentifier, otp }, showSpinner);

                    }
    }

export let MembershipClient = new _MembershipClient();

class _MessageOfTheDayClient {

    

                
            getAll(showSpinner = true): Promise<OM.MessageOfTheDay[]> {
                        return CommonServices.defaultGet<OM.MessageOfTheDay[]>(apiurl + 'api/MessageOfTheDay/GetAll',{  }, showSpinner);

                    }
    

                
            getMessageOfTheDay(showSpinner = true): Promise<OM.MessageOfTheDay> {
                        return CommonServices.defaultGet<OM.MessageOfTheDay>(apiurl + 'api/MessageOfTheDay/GetMessageOfTheDay',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.MessageOfTheDay,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/MessageOfTheDay/Save', item,{}, showSpinner );

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/MessageOfTheDay/Delete',{ identifier }, showSpinner);

                    }
    }

export let MessageOfTheDayClient = new _MessageOfTheDayClient();

class _NewsFeedItemClient {

    

                
            getAll(showSpinner = true): Promise<OM.NewsFeedItem[]> {
                        return CommonServices.defaultGet<OM.NewsFeedItem[]>(apiurl + 'api/NewsFeedItem/GetAll',{  }, showSpinner);

                    }
    

                
            getPublished(showSpinner = true): Promise<OM.NewsFeedItemListVm[]> {
                        return CommonServices.defaultGet<OM.NewsFeedItemListVm[]>(apiurl + 'api/NewsFeedItem/GetPublished',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.NewsFeedItem> {
                        return CommonServices.defaultGet<OM.NewsFeedItem>(apiurl + 'api/NewsFeedItem/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/NewsFeedItem/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.NewsFeedItem,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/NewsFeedItem/Save', item,{}, showSpinner );

                    }
    }

export let NewsFeedItemClient = new _NewsFeedItemClient();

class _OtpSignClient {

    

                
            sendOtpByMail(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/OtpSign/SendOtpByMail',{ userIdentifier }, showSpinner);

                    }
    

                
            sendOtpBySms(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/OtpSign/SendOtpBySms',{ userIdentifier }, showSpinner);

                    }
    

                
            hasOtpPending(
                userIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/OtpSign/HasOtpPending',{ userIdentifier }, showSpinner);

                    }
    

                
            canResendSms(
                userIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/OtpSign/CanResendSms',{ userIdentifier }, showSpinner);

                    }
    }

export let OtpSignClient = new _OtpSignClient();

class _PdfInterpolationTemplateClient {

    

                
            getTemplateNames(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/PdfInterpolationTemplate/GetTemplateNames',{  }, showSpinner);

                    }
    

                
            getVariables(
                templateName:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/PdfInterpolationTemplate/GetVariables',{ templateName }, showSpinner);

                    }
    

                
            save(
                template:OM.PdfInterpolationTemplate,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/PdfInterpolationTemplate/Save', template,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.PdfInterpolationTemplate[]> {
                        return CommonServices.defaultGet<OM.PdfInterpolationTemplate[]>(apiurl + 'api/PdfInterpolationTemplate/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.PdfInterpolationTemplate> {
                        return CommonServices.defaultGet<OM.PdfInterpolationTemplate>(apiurl + 'api/PdfInterpolationTemplate/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PdfInterpolationTemplate/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            toggleActive(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PdfInterpolationTemplate/ToggleActive',{ identifier }, showSpinner);

                    }
    }

export let PdfInterpolationTemplateClient = new _PdfInterpolationTemplateClient();

class _ProjectConfigClient {

    

                
            getProjectConfigByHost(
                host:string,showSpinner = true): Promise<OM.ProjectConfigVm> {
                        return CommonServices.defaultGet<OM.ProjectConfigVm>(apiurl + 'api/ProjectConfig/GetProjectConfigByHost',{ host }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.ProjectConfig[]> {
                        return CommonServices.defaultGet<OM.ProjectConfig[]>(apiurl + 'api/ProjectConfig/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ProjectConfig> {
                        return CommonServices.defaultGet<OM.ProjectConfig>(apiurl + 'api/ProjectConfig/GetById',{ identifier }, showSpinner);

                    }
    

                
            getWiredPaymentInstructions(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/ProjectConfig/GetWiredPaymentInstructions',{  }, showSpinner);

                    }
    

                
            getCryptoPaymentInstructions(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/ProjectConfig/GetCryptoPaymentInstructions',{  }, showSpinner);

                    }
    

                
            getProjectConfig(showSpinner = true): Promise<OM.ProjectConfig> {
                        return CommonServices.defaultGet<OM.ProjectConfig>(apiurl + 'api/ProjectConfig/GetProjectConfig',{  }, showSpinner);

                    }
    

                
            getPaymentMethods(showSpinner = true): Promise<OM.PaymentMethodDetails[]> {
                        return CommonServices.defaultGet<OM.PaymentMethodDetails[]>(apiurl + 'api/ProjectConfig/GetPaymentMethods',{  }, showSpinner);

                    }
    

                
            getPaymentRequestMethods(showSpinner = true): Promise<OM.PaymentRequestMethodDetails[]> {
                        return CommonServices.defaultGet<OM.PaymentRequestMethodDetails[]>(apiurl + 'api/ProjectConfig/GetPaymentRequestMethods',{  }, showSpinner);

                    }
    

                
            getProjectConfigVm(showSpinner = true): Promise<OM.ProjectConfigVm> {
                        return CommonServices.defaultGet<OM.ProjectConfigVm>(apiurl + 'api/ProjectConfig/GetProjectConfigVm',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.ProjectConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ProjectConfig/Save', item,{}, showSpinner );

                    }
    

                
            getAllProjectColors(showSpinner = true): Promise<OM.ProjectColorsPair[]> {
                        return CommonServices.defaultGet<OM.ProjectColorsPair[]>(apiurl + 'api/ProjectConfig/GetAllProjectColors',{  }, showSpinner);

                    }
    

                
            sendTestEmail(
                email:string,showSpinner = true): Promise<OM.ProjectColors> {
                        return CommonServices.defaultGet<OM.ProjectColors>(apiurl + 'api/ProjectConfig/SendTestEmail',{ email }, showSpinner);

                    }
    

                
            getProjectColors(showSpinner = true): Promise<OM.ProjectColors> {
                        return CommonServices.defaultGet<OM.ProjectColors>(apiurl + 'api/ProjectConfig/GetProjectColors',{  }, showSpinner);

                    }
    

                
            canShowNews(showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/ProjectConfig/CanShowNews',{  }, showSpinner);

                    }
    

                
            getDietTypes(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ProjectConfig/GetDietTypes',{  }, showSpinner);

                    }
    

                
            getDietTypesAllProjects(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ProjectConfig/GetDietTypesAllProjects',{  }, showSpinner);

                    }
    

                
            getStatuses(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ProjectConfig/GetStatuses',{  }, showSpinner);

                    }
    

                
            getSubStatuses(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ProjectConfig/GetSubStatuses',{  }, showSpinner);

                    }
    

                
            getProjectUrl(showSpinner = true): Promise<OM.UrlConfig> {
                        return CommonServices.defaultGet<OM.UrlConfig>(apiurl + 'api/ProjectConfig/GetProjectUrl',{  }, showSpinner);

                    }
    

                
            getPaymentConfigVm(showSpinner = true): Promise<OM.PaymentConfigVm> {
                        return CommonServices.defaultGet<OM.PaymentConfigVm>(apiurl + 'api/ProjectConfig/GetPaymentConfigVm',{  }, showSpinner);

                    }
    

                
            canRequestPayment(showSpinner = true): Promise<OM.CanRequestPaymentVm> {
                        return CommonServices.defaultGet<OM.CanRequestPaymentVm>(apiurl + 'api/ProjectConfig/CanRequestPayment',{  }, showSpinner);

                    }
    

                
            canOpenTicketV2(showSpinner = true): Promise<OM.GetOrariAperturaTicketVm> {
                        return CommonServices.defaultGet<OM.GetOrariAperturaTicketVm>(apiurl + 'api/ProjectConfig/CanOpenTicketV2',{  }, showSpinner);

                    }
    

                
            getPaymentRequestMinimumAmount(showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/ProjectConfig/GetPaymentRequestMinimumAmount',{  }, showSpinner);

                    }
    

                
            getCountriesList(showSpinner = true): Promise<OM.CountryConfig[]> {
                        return CommonServices.defaultGet<OM.CountryConfig[]>(apiurl + 'api/ProjectConfig/GetCountriesList',{  }, showSpinner);

                    }
    

                
            getCharityAmount(showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/ProjectConfig/GetCharityAmount',{  }, showSpinner);

                    }
    

                
            getPhonePrefixes(showSpinner = true): Promise<OM.PrefixCountry[]> {
                        return CommonServices.defaultGet<OM.PrefixCountry[]>(apiurl + 'api/ProjectConfig/GetPhonePrefixes',{  }, showSpinner);

                    }
    

                
            getEnabledCountries(showSpinner = true): Promise<OM.CountryConfig[]> {
                        return CommonServices.defaultGet<OM.CountryConfig[]>(apiurl + 'api/ProjectConfig/GetEnabledCountries',{  }, showSpinner);

                    }
    

                
            swaggetModelFiller(showSpinner = true): Promise<OM.SwaggerModelFiller> {
                        return CommonServices.defaultGet<OM.SwaggerModelFiller>(apiurl + 'api/ProjectConfig/SwaggetModelFiller',{  }, showSpinner);

                    }
    }

export let ProjectConfigClient = new _ProjectConfigClient();

class _PurchaseClient {

    

                
            getByCliente(
                clienteIdentifier:string,
                showHiddenToCustomer:boolean,showSpinner = true): Promise<OM.Purchase[]> {
                        return CommonServices.defaultGet<OM.Purchase[]>(apiurl + 'api/Purchase/GetByCliente',{ clienteIdentifier, showHiddenToCustomer }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.Purchase> {
                        return CommonServices.defaultGet<OM.Purchase>(apiurl + 'api/Purchase/GetById',{ identifier }, showSpinner);

                    }
    

                
            buyWithSaldo(
                vm:OM.CreateDeferredPaymentFromCartVm,showSpinner = true): Promise<OM.Purchase> {
                        return CommonServices.defaultPost<OM.Purchase>(apiurl + 'api/Purchase/BuyWithSaldo', vm,{}, showSpinner );

                    }
    

                
            makePurchaseManually(
                vm:OM.MakePurchaseManuallyVm,showSpinner = true): Promise<OM.Purchase> {
                        return CommonServices.defaultPost<OM.Purchase>(apiurl + 'api/Purchase/MakePurchaseManually', vm,{}, showSpinner );

                    }
    

                
            getPurchaseReceiptFile(
                purchaseIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/Purchase/GetPurchaseReceiptFile',{ purchaseIdentifier }, showSpinner);

                    }
    

                
            saveStorno(
                purchaseIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Purchase/SaveStorno',{ purchaseIdentifier }, showSpinner);

                    }
    

                
            getByFilterVm(
                vm:OM.PurchaseListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfPurchase> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfPurchase>(apiurl + 'api/Purchase/GetByFilterVm', vm,{}, showSpinner );

                    }
    

                
            exportExcelByFilterVm(
                vm:OM.PurchaseListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/Purchase/ExportExcelByFilterVm', vm,{}, showSpinner );

                    }
    

                
            getFatturatoByPeriod(
                fromDate:string,
                toDate:string,
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/Purchase/GetFatturatoByPeriod',{ fromDate, toDate, userIdentifier }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Purchase/Delete',{ identifier }, showSpinner);

                    }
    

                
            getSaldoCharity(showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/Purchase/GetSaldoCharity',{  }, showSpinner);

                    }
    

                
            downloadCustomerReceipt(
                purchaseIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/Purchase/DownloadCustomerReceipt',{ purchaseIdentifier }, showSpinner);

                    }
    }

export let PurchaseClient = new _PurchaseClient();

class _QualificationConfigClient {

    

                
            getQualifiche(showSpinner = true): Promise<OM.QualificationConfig[]> {
                        return CommonServices.defaultGet<OM.QualificationConfig[]>(apiurl + 'api/QualificationConfig/GetQualifiche',{  }, showSpinner);

                    }
    

                
            saveAll(
                items:OM.QualificationConfig[],showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/QualificationConfig/SaveAll', items,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/QualificationConfig/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getNextQualifica(
                currentQualificationCode:string,showSpinner = true): Promise<OM.QualificationConfig> {
                        return CommonServices.defaultGet<OM.QualificationConfig>(apiurl + 'api/QualificationConfig/GetNextQualifica',{ currentQualificationCode }, showSpinner);

                    }
    

                
            calcolaQualificheUtenti(showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/QualificationConfig/CalcolaQualificheUtenti',{  }, showSpinner);

                    }
    }

export let QualificationConfigClient = new _QualificationConfigClient();

class _RicettarioNodeClient {

    

                
            getById(
                ricettarioNodeIdentifier:string,showSpinner = true): Promise<OM.RicettarioNode> {
                        return CommonServices.defaultGet<OM.RicettarioNode>(apiurl + 'api/RicettarioNode/GetById',{ ricettarioNodeIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.RicettarioNode,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/RicettarioNode/Save', item,{}, showSpinner );

                    }
    

                
            addAnswerToNode(
                nodeIdentifier:string,showSpinner = true): Promise<OM.FaqNodeText> {
                        return CommonServices.defaultGet<OM.FaqNodeText>(apiurl + 'api/RicettarioNode/AddAnswerToNode',{ nodeIdentifier }, showSpinner);

                    }
    

                
            removeAnswerToNode(
                nodeIdentifier:string,
                answerIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/RicettarioNode/RemoveAnswerToNode',{ nodeIdentifier, answerIdentifier }, showSpinner);

                    }
    

                
            getRoot(showSpinner = true): Promise<OM.RicettarioNode> {
                        return CommonServices.defaultGet<OM.RicettarioNode>(apiurl + 'api/RicettarioNode/GetRoot',{  }, showSpinner);

                    }
    }

export let RicettarioNodeClient = new _RicettarioNodeClient();

class _SmsEventClient {

    

                
            getSmsEvents(showSpinner = true): Promise<OM.SmsEventDefinition[]> {
                        return CommonServices.defaultGet<OM.SmsEventDefinition[]>(apiurl + 'api/SmsEvent/GetSmsEvents',{  }, showSpinner);

                    }
    

                
            getByName(
                name:string,showSpinner = true): Promise<OM.SmsEventDefinition> {
                        return CommonServices.defaultGet<OM.SmsEventDefinition>(apiurl + 'api/SmsEvent/GetByName',{ name }, showSpinner);

                    }
    }

export let SmsEventClient = new _SmsEventClient();

class _SmsSentLogClient {

    

                
            getAllPaginated(
                vm:OM.SmsSentLogListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfSmsSentLog> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfSmsSentLog>(apiurl + 'api/SmsSentLog/GetAllPaginated', vm,{}, showSpinner );

                    }
    }

export let SmsSentLogClient = new _SmsSentLogClient();

class _StripeClient {

    

                
            checkPaymentDone(
                sessionId:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Stripe/CheckPaymentDone',{ sessionId }, showSpinner);

                    }
    

                
            createIntentForCart(
                cart:OM.ShoppingCart,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Stripe/CreateIntentForCart',{ cart, userIdentifier }, showSpinner);

                    }
    

                
            createClientPaymentConfigForCart(
                vm:OM.CreateClientPaymentConfigForCartRequestVm,showSpinner = true): Promise<OM.StripeClientPaymentConfig> {
                        return CommonServices.defaultPost<OM.StripeClientPaymentConfig>(apiurl + 'api/Stripe/CreateClientPaymentConfigForCart', vm,{}, showSpinner );

                    }
    

                
            createSessionForCart(
                cart:OM.ShoppingCart,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Stripe/CreateSessionForCart', cart,{}, showSpinner );

                    }
    }

export let StripeClient = new _StripeClient();

class _UserPaymentReceiptClient {

    

                
            removeUserReceipt(
                userReceiptIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/UserPaymentReceipt/RemoveUserReceipt',{ userReceiptIdentifier }, showSpinner);

                    }
    

                
            getSaldoCharity(showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/UserPaymentReceipt/GetSaldoCharity',{  }, showSpinner);

                    }
    }

export let UserPaymentReceiptClient = new _UserPaymentReceiptClient();

class _UserPaymentRequestClient {

    

                
            downloadUserPaymentRequestReceipt(
                userPaymentRequestIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/UserPaymentRequest/DownloadUserPaymentRequestReceipt',{ userPaymentRequestIdentifier }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.UserPaymentRequest[]> {
                        return CommonServices.defaultGet<OM.UserPaymentRequest[]>(apiurl + 'api/UserPaymentRequest/GetAll',{  }, showSpinner);

                    }
    

                
            exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/UserPaymentRequest/ExportExcel',{  }, showSpinner);

                    }
    

                
            generaRitenutaAcconto(
                paymentRequestIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/UserPaymentRequest/GeneraRitenutaAcconto',{ paymentRequestIdentifier }, showSpinner);

                    }
    

                
            approveRequest(
                receipt:OM.UserPaymentReceipt,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/UserPaymentRequest/ApproveRequest', receipt,{}, showSpinner );

                    }
    

                
            save(
                item:OM.UserPaymentReceipt,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/UserPaymentRequest/Save', item,{}, showSpinner );

                    }
    

                
            annullaRichiestaPagamento(
                requestIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/UserPaymentRequest/AnnullaRichiestaPagamento',{ requestIdentifier }, showSpinner);

                    }
    }

export let UserPaymentRequestClient = new _UserPaymentRequestClient();

class _VideoDellaSettimanaClient {

    

                
            getAll(showSpinner = true): Promise<OM.VideoDellaSettimana[]> {
                        return CommonServices.defaultGet<OM.VideoDellaSettimana[]>(apiurl + 'api/VideoDellaSettimana/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.VideoDellaSettimana> {
                        return CommonServices.defaultGet<OM.VideoDellaSettimana>(apiurl + 'api/VideoDellaSettimana/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VideoDellaSettimana/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getAsNameIdentifierByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/VideoDellaSettimana/GetAsNameIdentifierByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.VideoDellaSettimana,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/VideoDellaSettimana/Save', item,{}, showSpinner );

                    }
    }

export let VideoDellaSettimanaClient = new _VideoDellaSettimanaClient();

class _WallesterKeysConfigClient {

    

                
            getByProject(
                projectIdentifier:string,showSpinner = true): Promise<OM.WallesterKeysConfig> {
                        return CommonServices.defaultGet<OM.WallesterKeysConfig>(apiurl + 'api/WallesterKeysConfig/GetByProject',{ projectIdentifier }, showSpinner);

                    }
    

                
            setApiKey(
                projectIdentifier:string,
                apiKey:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/WallesterKeysConfig/SetApiKey',{ projectIdentifier, apiKey }, showSpinner);

                    }
    }

export let WallesterKeysConfigClient = new _WallesterKeysConfigClient();

class _WalletTransactionClient {

    

                
            save(
                item:OM.BaseWalletTransaction,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/WalletTransaction/Save', item,{}, showSpinner );

                    }
    

                
            makeTrasferimentoSaldo(
                vm:OM.CreateMoneyTransferVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/WalletTransaction/MakeTrasferimentoSaldo', vm,{}, showSpinner );

                    }
    

                
            payCommissionsToDate(
                processDate:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/WalletTransaction/PayCommissionsToDate',{ processDate }, showSpinner);

                    }
    

                
            saveManualBonus(
                vm:OM.SaveManualBonusVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/WalletTransaction/SaveManualBonus', vm,{}, showSpinner );

                    }
    

                
            getWalletTransactions(
                vm:OM.WalletTransactionsListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseWalletTransaction> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseWalletTransaction>(apiurl + 'api/WalletTransaction/GetWalletTransactions', vm,{}, showSpinner );

                    }
    

                
            removeTransaction(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/WalletTransaction/RemoveTransaction',{ identifier }, showSpinner);

                    }
    }

export let WalletTransactionClient = new _WalletTransactionClient();

class _SwapCreditTransactionClient {

    

                
            getBalance(
                customerIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/SwapCreditTransaction/GetBalance',{ customerIdentifier }, showSpinner);

                    }
    

                
            getAmountDueForExtension(
                customerIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/SwapCreditTransaction/GetAmountDueForExtension',{ customerIdentifier }, showSpinner);

                    }
    

                
            getByFilterVm(
                filterVm:OM.SwapCreditTransactionListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfSwapCreditTransaction> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfSwapCreditTransaction>(apiurl + 'api/SwapCreditTransaction/GetByFilterVm', filterVm,{}, showSpinner );

                    }
    

                
            saveManualTransaction(
                vm:OM.SaveSwapCreditTransactionVm,showSpinner = true): Promise<OM.SwapCreditTransaction> {
                        return CommonServices.defaultPost<OM.SwapCreditTransaction>(apiurl + 'api/SwapCreditTransaction/SaveManualTransaction', vm,{}, showSpinner );

                    }
    }

export let SwapCreditTransactionClient = new _SwapCreditTransactionClient();

class _SwapDailyReportClient {

    

                
            getByFilterVm(
                vm:OM.SwapDailyReportListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfSwapDailyReport> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfSwapDailyReport>(apiurl + 'api/SwapDailyReport/GetByFilterVm', vm,{}, showSpinner );

                    }
    

                
            getLastReport(
                customerIdentifier:string,showSpinner = true): Promise<OM.SwapDailyReport> {
                        return CommonServices.defaultGet<OM.SwapDailyReport>(apiurl + 'api/SwapDailyReport/GetLastReport',{ customerIdentifier }, showSpinner);

                    }
    

                
            exportExcel(
                vm:OM.SwapDailyReportListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/SwapDailyReport/ExportExcel', vm,{}, showSpinner );

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<OM.SwapDailyReport> {
                        return CommonServices.defaultGet<OM.SwapDailyReport>(apiurl + 'api/SwapDailyReport/Delete',{ identifier }, showSpinner);

                    }
    }

export let SwapDailyReportClient = new _SwapDailyReportClient();

class _SwapFundsClient {

    

                
            updateSwapFundDetails(
                vm:OM.UpdateSwapFundDetailVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/SwapFunds/UpdateSwapFundDetails', vm,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.SwapFund[]> {
                        return CommonServices.defaultGet<OM.SwapFund[]>(apiurl + 'api/SwapFunds/GetAll',{  }, showSpinner);

                    }
    

                
            resetFundExpirationFromToday(
                identifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/SwapFunds/ResetFundExpirationFromToday',{ identifier }, showSpinner);

                    }
    

                
            canPayExtension(
                customerIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/SwapFunds/CanPayExtension',{ customerIdentifier }, showSpinner);

                    }
    

                
            payAndExtendSwapFund(
                customerIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/SwapFunds/PayAndExtendSwapFund',{ customerIdentifier }, showSpinner);

                    }
    

                
            getTotalEarnedAmount(
                customerIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/SwapFunds/GetTotalEarnedAmount',{ customerIdentifier }, showSpinner);

                    }
    

                
            getEarnedAmountFromLastExtension(
                customerIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/SwapFunds/GetEarnedAmountFromLastExtension',{ customerIdentifier }, showSpinner);

                    }
    

                
            getByFilterVm(
                vm:OM.SwapFundListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfSwapFund> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfSwapFund>(apiurl + 'api/SwapFunds/GetByFilterVm', vm,{}, showSpinner );

                    }
    

                
            exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/SwapFunds/ExportExcel',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.SwapFund,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/SwapFunds/Save', item,{}, showSpinner );

                    }
    

                
            getByCustomer(
                customerIdentifier:string,showSpinner = true): Promise<OM.SwapFund> {
                        return CommonServices.defaultGet<OM.SwapFund>(apiurl + 'api/SwapFunds/GetByCustomer',{ customerIdentifier }, showSpinner);

                    }
    

                
            getSwapBalanceByNetwork(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/SwapFunds/GetSwapBalanceByNetwork',{ userIdentifier }, showSpinner);

                    }
    

                
            getSwapFundUserBalanceList(
                userIdentifier:string,showSpinner = true): Promise<OM.SwapFundUserBalanceVm[]> {
                        return CommonServices.defaultGet<OM.SwapFundUserBalanceVm[]>(apiurl + 'api/SwapFunds/GetSwapFundUserBalanceList',{ userIdentifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/SwapFunds/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            deleteListById(
                ids:string[],showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/SwapFunds/DeleteListById', ids,{}, showSpinner );

                    }
    }

export let SwapFundsClient = new _SwapFundsClient();

class _BaseProductClient {

    

                
            getAll(showSpinner = true): Promise<OM.BaseProduct[]> {
                        return CommonServices.defaultGet<OM.BaseProduct[]>(apiurl + 'api/BaseProduct/GetAll',{  }, showSpinner);

                    }
    

                
            getAllNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseProduct/GetAllNameIdentifier',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.BaseProduct> {
                        return CommonServices.defaultGet<OM.BaseProduct>(apiurl + 'api/BaseProduct/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.BaseProduct,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/BaseProduct/Save', item,{}, showSpinner );

                    }
    

                
            getProductTypes(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/BaseProduct/GetProductTypes',{  }, showSpinner);

                    }
    

                
            duplicaProdotto(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseProduct/DuplicaProdotto',{ identifier }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseProduct/Delete',{ identifier }, showSpinner);

                    }
    }

export let BaseProductClient = new _BaseProductClient();

class _ProductCourseClient {

    

                
            getCourse(
                identifier:string,showSpinner = true): Promise<OM.CourseProduct> {
                        return CommonServices.defaultGet<OM.CourseProduct>(apiurl + 'api/ProductCourse/GetCourse',{ identifier }, showSpinner);

                    }
    

                
            getClienteCourses(
                clienteIdentifier:string,showSpinner = true): Promise<OM.ProductCourseVm[]> {
                        return CommonServices.defaultGet<OM.ProductCourseVm[]>(apiurl + 'api/ProductCourse/GetClienteCourses',{ clienteIdentifier }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.BaseProduct[]> {
                        return CommonServices.defaultGet<OM.BaseProduct[]>(apiurl + 'api/ProductCourse/GetAll',{  }, showSpinner);

                    }
    

                
            getAllNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/ProductCourse/GetAllNameIdentifier',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.BaseProduct> {
                        return CommonServices.defaultGet<OM.BaseProduct>(apiurl + 'api/ProductCourse/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.BaseProduct,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ProductCourse/Save', item,{}, showSpinner );

                    }
    

                
            getProductTypes(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ProductCourse/GetProductTypes',{  }, showSpinner);

                    }
    

                
            duplicaProdotto(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ProductCourse/DuplicaProdotto',{ identifier }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ProductCourse/Delete',{ identifier }, showSpinner);

                    }
    }

export let ProductCourseClient = new _ProductCourseClient();

class _ShopCategoryClient {

    

                
            getAll(showSpinner = true): Promise<OM.ShopCategory[]> {
                        return CommonServices.defaultGet<OM.ShopCategory[]>(apiurl + 'api/ShopCategory/GetAll',{  }, showSpinner);

                    }
    

                
            getNameIdentifier(
                identifier:string,showSpinner = true): Promise<OM.LocalizedNameIdentifier> {
                        return CommonServices.defaultGet<OM.LocalizedNameIdentifier>(apiurl + 'api/ShopCategory/GetNameIdentifier',{ identifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ShopCategory> {
                        return CommonServices.defaultGet<OM.ShopCategory>(apiurl + 'api/ShopCategory/GetById',{ identifier }, showSpinner);

                    }
    

                
            getNameIdentifierList(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/ShopCategory/GetNameIdentifierList',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.ShopCategory,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShopCategory/Save', item,{}, showSpinner );

                    }
    

                
            getUpsellCategoryIdentifier(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/ShopCategory/GetUpsellCategoryIdentifier',{  }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopCategory/Delete',{ identifier }, showSpinner);

                    }
    

                
            getCategoriesForCliente(
                clienteIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/ShopCategory/GetCategoriesForCliente',{ clienteIdentifier }, showSpinner);

                    }
    }

export let ShopCategoryClient = new _ShopCategoryClient();

class _ShopOfferClient {

    

                
            getAll(showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetAll',{  }, showSpinner);

                    }
    

                
            attivaOffertaFromBackend(
                clienteIdentifier:string,
                offertaIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOffer/AttivaOffertaFromBackend',{ clienteIdentifier, offertaIdentifier }, showSpinner);

                    }
    

                
            checkContainsSpedibili(
                offerIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/ShopOffer/CheckContainsSpedibili',{ offerIdentifier }, showSpinner);

                    }
    

                
            checkContainsCorso(
                offerIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/ShopOffer/CheckContainsCorso',{ offerIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.IActivableOffer> {
                        return CommonServices.defaultGet<OM.IActivableOffer>(apiurl + 'api/ShopOffer/GetById',{ identifier }, showSpinner);

                    }
    

                
            getShopOfferById(
                identifier:string,showSpinner = true): Promise<OM.ShopOffer> {
                        return CommonServices.defaultGet<OM.ShopOffer>(apiurl + 'api/ShopOffer/GetShopOfferById',{ identifier }, showSpinner);

                    }
    

                
            getByCategory(
                shopCategoryIdentifier:string,showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetByCategory',{ shopCategoryIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.ShopOffer,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShopOffer/Save', item,{}, showSpinner );

                    }
    

                
            getAllAsNameIdentifier(
                showDisabled:boolean,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/ShopOffer/GetAllAsNameIdentifier',{ showDisabled }, showSpinner);

                    }
    

                
            disable(
                identifier:string,
                disable:boolean,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOffer/Disable',{ identifier, disable }, showSpinner);

                    }
    

                
            getOffersForCliente(
                customerIdentifier:string,
                categoryIdentifier:string,showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetOffersForCliente',{ customerIdentifier, categoryIdentifier }, showSpinner);

                    }
    

                
            duplicaOfferta(
                offertaIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOffer/DuplicaOfferta',{ offertaIdentifier }, showSpinner);

                    }
    

                
            deleteById(
                offertaIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOffer/DeleteById',{ offertaIdentifier }, showSpinner);

                    }
    

                
            getAllUpsellOffers(showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetAllUpsellOffers',{  }, showSpinner);

                    }
    

                
            getUpsellOffers(
                parentOfferIdentifier:string,showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetUpsellOffers',{ parentOfferIdentifier }, showSpinner);

                    }
    }

export let ShopOfferClient = new _ShopOfferClient();

class _ShoppingCartClient {

    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.ShoppingCart> {
                        return CommonServices.defaultGet<OM.ShoppingCart>(apiurl + 'api/ShoppingCart/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.ShoppingCart,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShoppingCart/Save', item,{}, showSpinner );

                    }
    

                
            clear(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShoppingCart/Clear',{ userIdentifier }, showSpinner);

                    }
    }

export let ShoppingCartClient = new _ShoppingCartClient();

class _TempOfferClient {

    

                
            getAll(showSpinner = true): Promise<OM.TempOffer[]> {
                        return CommonServices.defaultGet<OM.TempOffer[]>(apiurl + 'api/TempOffer/GetAll',{  }, showSpinner);

                    }
    

                
            createSwapFundCreditTempOffer(
                vm:OM.CreateSwapTempOfferVm,showSpinner = true): Promise<OM.TempOffer> {
                        return CommonServices.defaultPost<OM.TempOffer>(apiurl + 'api/TempOffer/CreateSwapFundCreditTempOffer', vm,{}, showSpinner );

                    }
    }

export let TempOfferClient = new _TempOfferClient();

class _PammConfigClient {

    

                
            getAll(showSpinner = true): Promise<OM.PammConfig[]> {
                        return CommonServices.defaultGet<OM.PammConfig[]>(apiurl + 'api/PammConfig/GetAll',{  }, showSpinner);

                    }
    

                
            getAllAsNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/PammConfig/GetAllAsNameIdentifier',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.PammConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/PammConfig/Save', item,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.PammConfig> {
                        return CommonServices.defaultGet<OM.PammConfig>(apiurl + 'api/PammConfig/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PammConfig/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let PammConfigClient = new _PammConfigClient();

class _PerformanceRowClient {

    

                
            getByFilterVm(
                vm:OM.PerformanceRowsListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfPerformanceRow> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfPerformanceRow>(apiurl + 'api/PerformanceRow/GetByFilterVm', vm,{}, showSpinner );

                    }
    }

export let PerformanceRowClient = new _PerformanceRowClient();

class _RebatesRowClient {

    

                
            getByFilterVm(
                vm:OM.RebateRowsListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfRebatesRow> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfRebatesRow>(apiurl + 'api/RebatesRow/GetByFilterVm', vm,{}, showSpinner );

                    }
    

                
            ricalcolaRebateRowSingle(
                rebateIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/RebatesRow/ricalcolaRebateRowSingle',{ rebateIdentifier }, showSpinner);

                    }
    

                
            exportExcel(
                vm:OM.RebateRowsListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/RebatesRow/ExportExcel', vm,{}, showSpinner );

                    }
    }

export let RebatesRowClient = new _RebatesRowClient();

class _SubscribedPammClient {

    

                
            updatePammDetails(
                vm:OM.UpdatePammDetailsVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/SubscribedPamm/UpdatePammDetails', vm,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.SubscribedPamm[]> {
                        return CommonServices.defaultGet<OM.SubscribedPamm[]>(apiurl + 'api/SubscribedPamm/GetAll',{  }, showSpinner);

                    }
    

                
            exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/SubscribedPamm/ExportExcel',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.SubscribedPamm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/SubscribedPamm/Save', item,{}, showSpinner );

                    }
    

                
            getSaldoTotaleOfUser(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/SubscribedPamm/GetSaldoTotaleOfUser',{ userIdentifier }, showSpinner);

                    }
    

                
            getSaldoTotaleByReteCommerciale(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/SubscribedPamm/GetSaldoTotaleByReteCommerciale',{ userIdentifier }, showSpinner);

                    }
    

                
            getSaldiByReteCommerciale(
                userIdentifier:string,showSpinner = true): Promise<OM.SaldoUserRowVm[]> {
                        return CommonServices.defaultGet<OM.SaldoUserRowVm[]>(apiurl + 'api/SubscribedPamm/GetSaldiByReteCommerciale',{ userIdentifier }, showSpinner);

                    }
    

                
            getPammDetailsByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.PammDetails[]> {
                        return CommonServices.defaultGet<OM.PammDetails[]>(apiurl + 'api/SubscribedPamm/GetPammDetailsByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.SubscribedPamm[]> {
                        return CommonServices.defaultGet<OM.SubscribedPamm[]>(apiurl + 'api/SubscribedPamm/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            activateWithVoucher(
                voucherIdentifier:string,
                clienteIdentifier:string,
                pammConfigIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/SubscribedPamm/ActivateWithVoucher',{ voucherIdentifier, clienteIdentifier, pammConfigIdentifier }, showSpinner);

                    }
    

                
            getSaldiUsers(showSpinner = true): Promise<OM.SaldoUserRowVm[]> {
                        return CommonServices.defaultGet<OM.SaldoUserRowVm[]>(apiurl + 'api/SubscribedPamm/GetSaldiUsers',{  }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/SubscribedPamm/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            deleteListById(
                ids:string[],showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/SubscribedPamm/DeleteListById', ids,{}, showSpinner );

                    }
    }

export let SubscribedPammClient = new _SubscribedPammClient();

class _InterpolationTemplateClient {

    

                
            getAll(showSpinner = true): Promise<OM.InterpolationTemplate[]> {
                        return CommonServices.defaultGet<OM.InterpolationTemplate[]>(apiurl + 'api/InterpolationTemplate/GetAll',{  }, showSpinner);

                    }
    

                
            getByEventName(
                eventName:string,showSpinner = true): Promise<OM.InterpolationTemplate[]> {
                        return CommonServices.defaultGet<OM.InterpolationTemplate[]>(apiurl + 'api/InterpolationTemplate/GetByEventName',{ eventName }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.InterpolationTemplate> {
                        return CommonServices.defaultGet<OM.InterpolationTemplate>(apiurl + 'api/InterpolationTemplate/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.InterpolationTemplate,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/InterpolationTemplate/Save', item,{}, showSpinner );

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/InterpolationTemplate/Delete',{ identifier }, showSpinner);

                    }
    }

export let InterpolationTemplateClient = new _InterpolationTemplateClient();

class _SmsTemplateClient {

    

                
            getAll(showSpinner = true): Promise<OM.SmsTemplate[]> {
                        return CommonServices.defaultGet<OM.SmsTemplate[]>(apiurl + 'api/SmsTemplate/GetAll',{  }, showSpinner);

                    }
    

                
            getByEventName(
                eventName:string,showSpinner = true): Promise<OM.SmsTemplate[]> {
                        return CommonServices.defaultGet<OM.SmsTemplate[]>(apiurl + 'api/SmsTemplate/GetByEventName',{ eventName }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.SmsTemplate> {
                        return CommonServices.defaultGet<OM.SmsTemplate>(apiurl + 'api/SmsTemplate/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.SmsTemplate,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/SmsTemplate/Save', item,{}, showSpinner );

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/SmsTemplate/Delete',{ identifier }, showSpinner);

                    }
    }

export let SmsTemplateClient = new _SmsTemplateClient();

class _BaseVoucherClient {

    

                
            getAll(
                vm:OM.VoucherListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseVoucher> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseVoucher>(apiurl + 'api/BaseVoucher/GetAll', vm,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseVoucher/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getByCliente(
                clienteIdentifier:string,showSpinner = true): Promise<OM.FoodPlanVoucher[]> {
                        return CommonServices.defaultGet<OM.FoodPlanVoucher[]>(apiurl + 'api/BaseVoucher/GetByCliente',{ clienteIdentifier }, showSpinner);

                    }
    }

export let BaseVoucherClient = new _BaseVoucherClient();

class _BookingVoucherClient {

    

                
            getAll(
                vm:OM.VoucherListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBookingVoucher> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBookingVoucher>(apiurl + 'api/BookingVoucher/GetAll', vm,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BookingVoucher/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getByCliente(
                clienteIdentifier:string,showSpinner = true): Promise<OM.BookingVoucher[]> {
                        return CommonServices.defaultGet<OM.BookingVoucher[]>(apiurl + 'api/BookingVoucher/GetByCliente',{ clienteIdentifier }, showSpinner);

                    }
    

                
            getAvailableBookingVoucher(
                userIdentifier:string,showSpinner = true): Promise<OM.BookingVoucher[]> {
                        return CommonServices.defaultGet<OM.BookingVoucher[]>(apiurl + 'api/BookingVoucher/GetAvailableBookingVoucher',{ userIdentifier }, showSpinner);

                    }
    

                
            getAvailableBookingVoucherByProfession(
                userIdentifier:string,
                professionIdentifier:string,showSpinner = true): Promise<OM.BookingVoucher[]> {
                        return CommonServices.defaultGet<OM.BookingVoucher[]>(apiurl + 'api/BookingVoucher/GetAvailableBookingVoucherByProfession',{ userIdentifier, professionIdentifier }, showSpinner);

                    }
    }

export let BookingVoucherClient = new _BookingVoucherClient();

class _PammVoucherClient {

    

                
            getAll(
                vm:OM.PammVoucherListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfPammVoucher> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfPammVoucher>(apiurl + 'api/PammVoucher/GetAll', vm,{}, showSpinner );

                    }
    

                
            getAvailableByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.PammVoucher[]> {
                        return CommonServices.defaultGet<OM.PammVoucher[]>(apiurl + 'api/PammVoucher/GetAvailableByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.PammVoucher,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/PammVoucher/Save', item,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.PammVoucher[]> {
                        return CommonServices.defaultGet<OM.PammVoucher[]>(apiurl + 'api/PammVoucher/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PammVoucher/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let PammVoucherClient = new _PammVoucherClient();

class _BaseUserClient {

    

                
            update(
                item:OM.BaseUser,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/Update', item,{}, showSpinner );

                    }
    

                
            getUserType(
                userIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/BaseUser/GetUserType',{ userIdentifier }, showSpinner);

                    }
    

                
            getListForNetwork(
                roleFilter:string,
                userToExclude:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetListForNetwork',{ roleFilter, userToExclude }, showSpinner);

                    }
    

                
            assignToNode(
                vm:OM.AssignToVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AssignToNode', vm,{}, showSpinner );

                    }
    

                
            acceptGestione(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/AcceptGestione',{ userIdentifier }, showSpinner);

                    }
    

                
            voidGestione(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/VoidGestione',{ userIdentifier }, showSpinner);

                    }
    

                
            setPreferredCulture(
                culture:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/SetPreferredCulture',{ culture }, showSpinner);

                    }
    

                
            getShippingAddress(
                userIdentifier:string,showSpinner = true): Promise<OM.Address> {
                        return CommonServices.defaultGet<OM.Address>(apiurl + 'api/BaseUser/GetShippingAddress',{ userIdentifier }, showSpinner);

                    }
    

                
            getNameIdentifier(
                userIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/BaseUser/GetNameIdentifier',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.BaseUser,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/BaseUser/Save', item,{}, showSpinner );

                    }
    

                
            attivaOffertaMultipleFromBackend(
                vm:OM.ActivateOfferOnMultipleCustomersVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AttivaOffertaMultipleFromBackend', vm,{}, showSpinner );

                    }
    

                
            removeComment(
                identifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/RemoveComment',{ identifier, userIdentifier }, showSpinner);

                    }
    

                
            removeNota(
                identifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/RemoveNota',{ identifier, userIdentifier }, showSpinner);

                    }
    

                
            setPassword(
                userIdentifier:string,
                password:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/BaseUser/SetPassword',{ userIdentifier, password }, showSpinner);

                    }
    

                
            getAll(
                vm:OM.BaseUserListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseUserTableVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseUserTableVm>(apiurl + 'api/BaseUser/GetAll', vm,{}, showSpinner );

                    }
    

                
            getNameIdentifiers(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetNameIdentifiers',{  }, showSpinner);

                    }
    

                
            getNameIdentifierByReferralCode(
                referralCode:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/BaseUser/GetNameIdentifierByReferralCode',{ referralCode }, showSpinner);

                    }
    

                
            searchCliente(
                search:string,
                userIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/SearchCliente',{ search, userIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.BaseUser> {
                        return CommonServices.defaultGet<OM.BaseUser>(apiurl + 'api/BaseUser/GetById',{ identifier }, showSpinner);

                    }
    

                
            getCustomerById(
                identifier:string,showSpinner = true): Promise<OM.Customer> {
                        return CommonServices.defaultGet<OM.Customer>(apiurl + 'api/BaseUser/GetCustomerById',{ identifier }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/Delete',{ identifier }, showSpinner);

                    }
    

                
            promoteToOperator(
                identifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/BaseUser/PromoteToOperator',{ identifier }, showSpinner);

                    }
    

                
            getDescendantsManagersNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetDescendantsManagersNameIdentifier',{  }, showSpinner);

                    }
    

                
            getManagerNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetManagerNameIdentifier',{  }, showSpinner);

                    }
    

                
            getCentroFumoDetails(
                identifier:string,showSpinner = true): Promise<OM.ContactData> {
                        return CommonServices.defaultGet<OM.ContactData>(apiurl + 'api/BaseUser/GetCentroFumoDetails',{ identifier }, showSpinner);

                    }
    

                
            getAllOperators(showSpinner = true): Promise<OM.Operator[]> {
                        return CommonServices.defaultGet<OM.Operator[]>(apiurl + 'api/BaseUser/GetAllOperators',{  }, showSpinner);

                    }
    

                
            exportOperatorExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/BaseUser/ExportOperatorExcel',{  }, showSpinner);

                    }
    

                
            getOperatorById(
                identifier:string,showSpinner = true): Promise<OM.Operator> {
                        return CommonServices.defaultGet<OM.Operator>(apiurl + 'api/BaseUser/GetOperatorById',{ identifier }, showSpinner);

                    }
    

                
            getAllOperatorsNameIdentifier(
                showDisabled:boolean,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetAllOperatorsNameIdentifier',{ showDisabled }, showSpinner);

                    }
    

                
            getOperatorDescendantsNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetOperatorDescendantsNameIdentifier',{  }, showSpinner);

                    }
    

                
            addLinkedAccount(
                vm:OM.LoginVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/BaseUser/AddLinkedAccount', vm,{}, showSpinner );

                    }
    

                
            removeLinkedAccount(
                removeIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/RemoveLinkedAccount',{ removeIdentifier }, showSpinner);

                    }
    

                
            getLeadInAccettazione(
                filter:OM.LeadInAccettazioneFilterVm,showSpinner = true): Promise<OM.LeadInAccettazioneResponseVm> {
                        return CommonServices.defaultPost<OM.LeadInAccettazioneResponseVm>(apiurl + 'api/BaseUser/GetLeadInAccettazione', filter,{}, showSpinner );

                    }
    

                
            updateContactAddress(
                vm:OM.UpdateAddressVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdateContactAddress', vm,{}, showSpinner );

                    }
    

                
            getProfonditaNodo(
                fromNode:string,
                toNode:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/BaseUser/GetProfonditaNodo',{ fromNode, toNode }, showSpinner);

                    }
    

                
            setChiamato(
                leadIdentifier:string,
                value:boolean,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/SetChiamato',{ leadIdentifier, value }, showSpinner);

                    }
    

                
            updateFiscalCode(
                leadIdentifier:string,
                newCodFisc:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/UpdateFiscalCode',{ leadIdentifier, newCodFisc }, showSpinner);

                    }
    

                
            updateLuogoDataNascita(
                vm:OM.UpdateLuogoDataNascitaVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdateLuogoDataNascita', vm,{}, showSpinner );

                    }
    

                
            updateFiscalAddress(
                vm:OM.UpdateAddressVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdateFiscalAddress', vm,{}, showSpinner );

                    }
    

                
            updatePersonalData(
                vm:OM.UpdatePersonalDataVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdatePersonalData', vm,{}, showSpinner );

                    }
    

                
            updateFiscalData(
                vm:OM.UpdateFiscalDataVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdateFiscalData', vm,{}, showSpinner );

                    }
    

                
            saveContactEmail(
                leadIdentifier:string,
                newEmail:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/SaveContactEmail',{ leadIdentifier, newEmail }, showSpinner);

                    }
    

                
            getAllNameIdentifiers(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetAllNameIdentifiers',{  }, showSpinner);

                    }
    

                
            requestResetPassword(
                userEmail:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/RequestResetPassword',{ userEmail }, showSpinner);

                    }
    

                
            resetPassword(
                model:OM.ResetPasswordVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/ResetPassword', model,{}, showSpinner );

                    }
    

                
            confirmEmail(
                userIdentifier:string,
                confirmationCode:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/ConfirmEmail',{ userIdentifier, confirmationCode }, showSpinner);

                    }
    

                
            getLeadById(
                identifier:string,showSpinner = true): Promise<OM.Lead> {
                        return CommonServices.defaultGet<OM.Lead>(apiurl + 'api/BaseUser/GetLeadById',{ identifier }, showSpinner);

                    }
    

                
            getAllLeads(showSpinner = true): Promise<OM.Lead[]> {
                        return CommonServices.defaultGet<OM.Lead[]>(apiurl + 'api/BaseUser/GetAllLeads',{  }, showSpinner);

                    }
    

                
            getStoricoAssegnazioni(
                leadIdentifier:string,showSpinner = true): Promise<OM.DateValueOfNodeAssignment[]> {
                        return CommonServices.defaultGet<OM.DateValueOfNodeAssignment[]>(apiurl + 'api/BaseUser/GetStoricoAssegnazioni',{ leadIdentifier }, showSpinner);

                    }
    

                
            getAssegnazioni(
                startDate:string,
                endDate:string,
                userIdentifier:string,
                descendants:boolean,showSpinner = true): Promise<OM.LeadAssignmentHistoryVm[]> {
                        return CommonServices.defaultGet<OM.LeadAssignmentHistoryVm[]>(apiurl + 'api/BaseUser/GetAssegnazioni',{ startDate, endDate, userIdentifier, descendants }, showSpinner);

                    }
    

                
            setLavorato(
                leadIdentifier:string,
                value:boolean,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/SetLavorato',{ leadIdentifier, value }, showSpinner);

                    }
    

                
            getTelephoneNumber(
                leadIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/BaseUser/GetTelephoneNumber',{ leadIdentifier }, showSpinner);

                    }
    

                
            assignToList(
                leadIdentifier:string,
                list:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/AssignToList',{ leadIdentifier, list }, showSpinner);

                    }
    

                
            assignToNoneMultiple(
                leadList:string[],showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AssignToNoneMultiple', leadList,{}, showSpinner );

                    }
    

                
            assignMultipleToUser(
                vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AssignMultipleToUser', vm,{}, showSpinner );

                    }
    

                
            assignMultipleToList(
                vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AssignMultipleToList', vm,{}, showSpinner );

                    }
    

                
            changeStatus(
                leadIdentifier:string,
                status:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/ChangeStatus',{ leadIdentifier, status }, showSpinner);

                    }
    

                
            setToDoDone(
                userIdentifier:string,
                toDoIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/SetToDoDone',{ userIdentifier, toDoIdentifier }, showSpinner);

                    }
    

                
            changeStatusToMultiple(
                vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/ChangeStatusToMultiple', vm,{}, showSpinner );

                    }
    

                
            changeSubStatus(
                leadIdentifier:string,
                subStatus:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/ChangeSubStatus',{ leadIdentifier, subStatus }, showSpinner);

                    }
    

                
            changeSubStatusToMultiple(
                vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/ChangeSubStatusToMultiple', vm,{}, showSpinner );

                    }
    

                
            acceptAssignmentMultiple(
                leads:string[],showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AcceptAssignmentMultiple', leads,{}, showSpinner );

                    }
    

                
            denyAssignmentMultiple(
                leads:string[],showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/DenyAssignmentMultiple', leads,{}, showSpinner );

                    }
    

                
            getContactDataOfUser(
                userIdentifier:string,showSpinner = true): Promise<OM.ContactData> {
                        return CommonServices.defaultGet<OM.ContactData>(apiurl + 'api/BaseUser/GetContactDataOfUser',{ userIdentifier }, showSpinner);

                    }
    

                
            checkUsername(
                checkthis:OM.CheckEmailVm,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultPost<boolean>(apiurl + 'api/BaseUser/CheckUsername', checkthis,{}, showSpinner );

                    }
    

                
            checkNumber(
                checkthis:OM.CheckNumberVm,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultPost<boolean>(apiurl + 'api/BaseUser/CheckNumber', checkthis,{}, showSpinner );

                    }
    

                
            oblioCliente(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/OblioCliente',{ userIdentifier }, showSpinner);

                    }
    

                
            recalculateNames(showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/RecalculateNames',{  }, showSpinner);

                    }
    }

export let BaseUserClient = new _BaseUserClient();

class _CustomerClient {

    

                
            getAll(
                vm:OM.CustomerListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfCustomerTableVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfCustomerTableVm>(apiurl + 'api/Customer/GetAll', vm,{}, showSpinner );

                    }
    }

export let CustomerClient = new _CustomerClient();

class _LeadClient {

    

                
            getByList(
                vm:OM.LeadListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfLeadTableVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfLeadTableVm>(apiurl + 'api/Lead/GetByList', vm,{}, showSpinner );

                    }
    

                
            exportLeads(
                vm:OM.LeadListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/Lead/ExportLeads', vm,{}, showSpinner );

                    }
    

                
            createList(
                listname:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Lead/CreateList',{ listname }, showSpinner);

                    }
    

                
            getLists(showSpinner = true): Promise<OM.LeadList[]> {
                        return CommonServices.defaultGet<OM.LeadList[]>(apiurl + 'api/Lead/GetLists',{  }, showSpinner);

                    }
    

                
            removeList(
                listname:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Lead/RemoveList',{ listname }, showSpinner);

                    }
    

                
            getByStatusAsColonne(
                userIdentifier:string,
                descendants:boolean,showSpinner = true): Promise<{ [key:string]:OM.LeadTableVm[]; }> {
                        return CommonServices.defaultGet<{ [key:string]:OM.LeadTableVm[]; }>(apiurl + 'api/Lead/GetByStatusAsColonne',{ userIdentifier, descendants }, showSpinner);

                    }
    }

export let LeadClient = new _LeadClient();

class _OperatorClient {

    

                
            getAll(
                vm:OM.BaseUserListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseUserTableVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseUserTableVm>(apiurl + 'api/Operator/GetAll', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.Operator> {
                        return CommonServices.defaultGet<OM.Operator>(apiurl + 'api/Operator/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.Operator,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Operator/Save', item,{}, showSpinner );

                    }
    

                
            create(
                vm:OM.CreateUserVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Operator/Create', vm,{}, showSpinner );

                    }
    

                
            getListForNetwork(
                roleFilter:string,
                userToExclude:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/Operator/GetListForNetwork',{ roleFilter, userToExclude }, showSpinner);

                    }
    

                
            setObiettivoMensile(
                userIdentifier:string,
                obiettivo:number,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Operator/SetObiettivoMensile',{ userIdentifier, obiettivo }, showSpinner);

                    }
    

                
            getGuadagniObiettivoMensileByMonthResult(
                userIdentifier:string,
                month:number,
                year:number,showSpinner = true): Promise<OM.ObiettivoMensileVm> {
                        return CommonServices.defaultGet<OM.ObiettivoMensileVm>(apiurl + 'api/Operator/GetGuadagniObiettivoMensileByMonthResult',{ userIdentifier, month, year }, showSpinner);

                    }
    }

export let OperatorClient = new _OperatorClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}